<div class="agent-selector" *ngIf="agentCount > 0">
    <div class="agent-section-header">
        <span class="agent-section-title">Agents ({{ agentCount }})</span>
    </div>

    <div class="agent-list">
        <button
            type="button"
            class="agent-item"
            *ngFor="let agent of availableAgents"
            (click)="selectAgent(agent)"
            [class.active]="isActiveAgent(agent.id)">
            <!-- ✅ Agent Icon -->
            <div class="agent-item-content">
                <img *ngIf="agent.icon" [src]="agent.icon" [alt]="agent.display_name" class="agent-item-icon">
                <span class="agent-name">{{ (agent.display_name || "")| translate }}</span>
            </div>
        </button>
    </div>
</div>